module.exports = __webpack_public_path__ + "media/cymbal001.a424e524.wav";